import React from 'react';
import TagList from './TagList';
import withSearchState from 'app/withSearchState';

const Tag = ({ getUriState, pushUriStateWithoutPage }) => {
  const { tag } = getUriState();
  const handleChange = e => {
    pushUriStateWithoutPage({ tag: e.target.value });
  };
  return <TagList value={tag} onChange={handleChange} />;
};

export default withSearchState(Tag);
